<header class="header" appBlockCopyPaste>
    <div class="header-main">
        <span class="logo-label">
            <img src="../../assets/logo.png">
        </span>
        <div class="header-links">
            <a class="active-item button button-text button-text-dark header-secondary-button"
                (click)="helpClick()"
                [routerLinkActive]="['active-item']">
                Help
            </a>
        </div>
    </div>
</header>